/* APPLICATION ROUTE CONSTANTS */
module.exports = Object.freeze({
  ROW_PER_PAGE: [10, 50, 100, 300, 500],

  // Status
  STATUS_REGISTER: "Register",

  /* Routers Link supplier_app */
  APP_HOME: "/applications",
  HOME: "/home",

  HOME_INTRO: "/plm-intro",
  DASHBOARD: "/plm-dashboard",
  INBOX: "/plm-inbox",
  OUTBOX: "/plm-outbox",

  /* Master */
  /* Prodcut Articles */
  PRODUCT_ARTICLES_ARTICLE_CREATION: "/article-creation",
  PRODUCT_ARTICLES_ARTICLE_DETAILS: "/article-details",
  PRODUCT_ARTICLES_ARTICLE_LIST: "/article-list",
  PRODUCT_ARTICLES_ARTICLE: "/product-article",
  PRODUCT_ARTICLE_MASTER_BULK_UPLOAD:"/article-master-bulk-upload",

  // product Matrix Creation
  PRODUCT_MATRIX_PRODUCTMATRIX_CREATION: "/product-matrix-creation",
  PRODUCT_MATRIX_PRODUCTMATRIX_DETAILS: "/product-matrix-details",

  PRODUCT_MATRIX_PRODUCTMATRIX_LIST: "/product-matrix-list",
  PRODUCT_MATRIX_PRODUCTMATRIX_CREATIONP2: "/product-matrix-creationp2",
  
});
